import styled from "@emotion/styled"
import hash from "@emotion/hash"
import { motion, useTransform, transform } from "framer-motion"

import { useViewport } from "contexts/Viewport"

import { headline100, headline50, surtitle100 } from "css/text"
import getMediaQuery from "css/breakpoints"
import { contrastMode } from "css/a11y"

export const kickerCN = hash("page-heading:kicker")
export const subtitleCN = hash("page-heading:subtitle")

const Hgroup = styled(motion.hgroup)`
  text-align: center;
  /* color: white; */
  padding-block-start: 40vh;
  padding-block-end: 60vh;

  display: grid;
  grid-template-rows: [kicker subtitle] min-content [mid-line] min-content [title];

  position: sticky;
  top: 0;
  align-self: start;

  /* height: fit-content; */

  & h2 {
    ${headline100}
  }

  & h2.long {
    ${headline50}
  }

  & h2,
  & p {
    position: relative;
    ${contrastMode}
  }

  & .${kickerCN} {
    ${surtitle100}
    grid-row: kicker / mid-line;
  }

  & .${subtitleCN} {
    ${surtitle100}
    grid-row: subtitle / mid-line;
  }
`

const Track = styled.div`
  grid-row: title;
  grid-column: col 1 / span 6;
  align-self: stretch;

  ${getMediaQuery("m")} {
    grid-column: col 2 / span 10;
  }

  ${getMediaQuery("l")} {
    grid-column: col 3 / span 8;
  }
`

export default function SubHeading({ theme, kicker, title, subtitle, prog, has_long_sub_heading }) {
  const { height } = useViewport()

  const opacity = useTransform([prog, height], ([p, h]) => transform(p, [h * 0.1, h * 0.15, h * 0.5, h * 0.9], [0, 1, 1, 0]))

  return (
    <Track className={`${theme} subheading`}>
      <Hgroup style={{ opacity }}>
        {kicker && <p className={kickerCN}>{kicker}</p>}
        <h2 className={has_long_sub_heading ? "long" : null} dangerouslySetInnerHTML={{ __html: title }} />
        {subtitle && <p className={subtitleCN}>{subtitle}</p>}
      </Hgroup>
    </Track>
  )
}
